import { Component, Input, OnInit } from '@angular/core';
import { ConcursoProvaData } from 'src/app/models/concurso-prova-data';

@Component({
  selector: 'table-provas-ativas-examinador',
  templateUrl: './table-provas-ativas-examinador.component.html',
  styleUrls: ['./table-provas-ativas-examinador.component.scss'],
})
export class TableProvasAtivasExaminadorComponent implements OnInit {
  @Input() concursosProvasData: ConcursoProvaData[] = [];
  filteredConcursosProvasData: ConcursoProvaData[] = [];

  ngOnInit(): void {
    const now = new Date();
    const lastMonth = new Date();
    lastMonth.setMonth(now.getMonth() - 1);

    this.filteredConcursosProvasData = this.concursosProvasData.filter(concurso => {
      const data1 = new Date(concurso.data1fase);
      const data2 = new Date(concurso.data2fase);

      return data1 > lastMonth || data2 > lastMonth;
    });
  }
}
